"use client"

import { useState } from "react"

import type { CourseFaqItem } from "@/types/database"

import { SalesIcon } from "./icons"

/** FAQ: uma pergunta aberta por vez, todas fechadas no load. */
export function FaqAccordion({ faq }: { faq: CourseFaqItem[] }) {
  const [open, setOpen] = useState(-1)

  return (
    <div className="mt-7 lg:mt-0">
      {faq.map((item, i) => {
        const isOpen = open === i
        return (
          <div key={item.question} className="border-t border-sales-line">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-start gap-4 py-[18px] text-left"
            >
              <span className="flex-1 font-heading text-[15px] leading-[1.35] font-semibold tracking-[-0.018em] text-sales-ink sm:text-[16.5px]">
                {item.question}
              </span>
              <SalesIcon.chevron
                width={15}
                height={15}
                className={`mt-1 shrink-0 text-sales-text-mid transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            {isOpen && (
              <p className="max-w-[62ch] pr-8 pb-5 text-[13.5px] leading-[1.65] text-pretty text-sales-text sm:text-[14.5px]">
                {item.answer}
              </p>
            )}
          </div>
        )
      })}
      <div className="border-t border-sales-line" />
    </div>
  )
}
